module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse-panel"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "header-title"
  }, [_vm._t("title"), _vm._v(" "), _vm._t("port"), _vm._v(" "), _vm._t("time")], 2), _vm._v(" "), (!_vm.isCollapsed) ? _c('Icon', {
    staticClass: "icon",
    attrs: {
      "type": "chevron-up",
      "size": "18"
    },
    on: {
      "click": _vm.handleToggle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCollapsed) ? _c('Icon', {
    staticClass: "icon",
    attrs: {
      "type": "chevron-down",
      "size": "18"
    },
    on: {
      "click": _vm.handleToggle
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCollapsed),
      expression: "!isCollapsed"
    }],
    staticClass: "section-conent"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1b904950", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b904950"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/place-order/collapse-panel.vue
// module id = 1300
// module chunks = 61